import { useContext as m, useMemo as e, useCallback as u } from "react";
import { getLocaleByLanguageCode as c } from "../locales/language-utils.mjs";
import { LocaleContext as s } from "../../i18n/context.mjs";
import { getCountryData as C, getCountryName as g } from "./get-country-data.mjs";
import { LocaleEnum as l } from "../../libs/types/dist/index11.mjs";
const N = () => {
  const { currentLanguageCode: t } = m(s) ?? {}, o = e(
    () => t ? c(t) : l.ENGLISH,
    [t]
  ), r = e(() => C(o), [o]), a = u(
    (n) => g(n, o),
    [o]
  );
  return { countryData: r, getCountryName: a };
};
export {
  N as useLocalizedCountries
};
